import React from "react";
import { useUserContext } from "context/UserContext";
import CouponManagementBK from "layouts/BK/couponManagement";
import { isManagementRoleLevel, normalizeRoleLevel } from "utils/roleUtils";

function CouponManagement() {
  const { roleLevel } = useUserContext() || {};
  if (isManagementRoleLevel(normalizeRoleLevel(roleLevel))) {
    return <CouponManagementBK />;
  }
  return null;
}

export default CouponManagement;
